import React from "react";
import styles from "./CivilLaw.module.css";
import CustomTitle from "../components/CustomTitle";
//import LocationFooter from "./LocationFooter";
const CorporateLaw = () => {
  return (
    <>
      <section className={styles.practiceAreas}>
        <CustomTitle>Commercial & Corporate Law</CustomTitle>

        <div className={styles.practiceList}>
          <div className={styles.practiceCard}>
            <h3>Commercial Law</h3>
            <p>
              Our commercial law practice is built around supporting trade and
              commerce with sound legal foundations. We handle matters relating
              to sale of goods, service agreements, agency arrangements,
              franchising, leasing, and distribution. Our team also manages
              disputes arising out of trade practices, commercial transactions,
              and business contracts. We are committed to providing businesses
              with clarity, compliance, and conflict resolution so that they can
              focus on growth without legal hurdles.
            </p>
            <h3>Corporate Law</h3>
            <p>
              Our corporate law practice delivers comprehensive legal solutions
              tailored to businesses of every scale—from startups to
              multinational corporations. We assist with company incorporations,
              corporate governance, mergers and acquisitions, joint ventures,
              restructuring, and compliance with regulatory frameworks. Our
              corporate advisory services are designed to ensure businesses not
              only meet their legal obligations but also thrive in competitive
              markets. We also provide drafting and vetting of complex
              commercial contracts, shareholder agreements, and policy
              documents, keeping our clients’ business goals at the forefront.
            </p>
            <ul>
              <li>Contract drafting and negotiation.</li>
              <li>Corporate governance.</li>
              <li>Joint ventures and partnerships.</li>
              <li>Arbitration and dispute resolution.</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  <LocationFooter /> */}
    </>
  );
};

export default CorporateLaw;
